module.exports = __webpack_public_path__ + "static/collaborate-04160252704a7b7096186d2099b18c90.jpg";